import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setupAgGrid } from './grid-setup';

setupAgGrid();

const container = document.getElementById('root');
if (!container) throw new Error('#root не найден в index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
